/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import StudentResults from '../../types/StudentResults';

interface State {
  ids: number[];
  values: Record<number, StudentResults>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const studentsResultsSlice = createSlice({
  name: 'studentsResults',
  initialState,
  reducers: {
    setAllStudentsResults: (state, action: PayloadAction<StudentResults[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { userId } = value;
        state.ids.push(userId);
        state.values[userId] = value;
      });
    },
  },
});

export const selectStudentsResults = (
  state: any,
): Record<number, StudentResults> => state.studentsResults.values;

export const { setAllStudentsResults } = studentsResultsSlice.actions;
export default studentsResultsSlice.reducer;
